// Ajax cart JS for Drawer and Cart Page
(function ensureB2bQtyHelpers() {
  if (!window.__b2bQtySyncChain) window.__b2bQtySyncChain = Promise.resolve();
  if (!window.enqueueB2bCartSync) {
    window.enqueueB2bCartSync = function (fn) {
      var next = window.__b2bQtySyncChain.then(function () {
        return fn();
      });
      window.__b2bQtySyncChain = next.catch(function () {
        return undefined;
      });
      return next;
    };
  }
})();

const B2B_BAG_QTY_DEBOUNCE_MS = 400;

const drawerSelectors = {
  quickShopModal: document.querySelector('quick-shop'),
  cartIcons: document.querySelectorAll('.header__icon--cart'),
  cartIconDesktop: document.querySelector('#cart-icon-desktop'),
  cartIconMobile: document.querySelector('#cart-icon-mobile'),
  cartCloseBtn: document.querySelector('.close-ajax--cart')
};

class AjaxCart extends HTMLElement {
    constructor() {
      super();
  
      this.openeBy = drawerSelectors.cartIcons;
      this.isOpen =  this.classList.contains('open--drawer');
      this.cartForm = this.querySelector('form');
      this.sectionID = 'component-cart-drawer';
      this.bxgyDiscountDetails;
      this._b2bBagDebounceTimers = {};
      this._onRemoveItemClick = this.removeItem.bind(this);
      this._onQtyBtnClick = this.manageQtyBtn.bind(this);
      this._onQtyInputChange = this.onQtyChange.bind(this);

      if(window.globalVariables.template == 'cart'){
        this.style.visibility = 'visible';
        this.sectionID = document.getElementById('cart--items').dataset.id;
      }else{
        this.addAccessibilityAttributes(this.openeBy);
        this.getCartData();
      }

      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }
  
    connectedCallback() {
      this.bindEvents();
      this.cartNoteInput();
    }

    /**
     * Observe attribute of component
     * 
     * @returns {array} Attributes to Observe
     */
    static get observedAttributes() {
      return ['updating'];
    }
  
    /**
     * To Perform operation when attribute is changed
     * Calls attributeChangedCallback() with params when attribute value is updated
     * 
     * @param {string} name attribute name
     * @param {string} oldValue attribute Old value
     * @param {string} newValue attribute latest value
     */
    attributeChangedCallback(name, _oldValue, newValue) {
      // called when one of attributes listed above is modified
      if(name === 'updating' && newValue === 'false'){
        this.updateEvents();
      }
    }
  
    /**
     * Add accessibility attributes to Open Drawer buttons
     * 
     * @param {Node Array} openDrawerButtons Cart Icons
     */
    addAccessibilityAttributes(openDrawerButtons) {
      let _this = this;
      openDrawerButtons.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', _this.id);
      });
    }
  
    /**
     * Escape Click event to close drawer when focused within Cart Drawer
     *
     * @param {event} Event instance
     */
    onKeyUp(event) {
      if(event.code.toUpperCase() !== 'ESCAPE') return;
      drawerSelectors.cartCloseBtn.dispatchEvent(new Event('click'));
    }
  
    /**
     * bind dclick and keyup event to Cart Icons
     * bind keyUp event to Cart drawer component
     * bind Other inside element events
     *
     */
    bindEvents() {
      if(window.globalVariables.template !== 'cart'){
        if (!window.customer?.b2b) {
          this.openeBy.forEach(cartBtn => cartBtn.addEventListener('click', this.openCartDrawer.bind(this)));
        }
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        drawerSelectors.cartCloseBtn.addEventListener('click', this.closeCartDrawer.bind(this));
      }
      this.updateEvents();
    }

    /**
     * bind Other inside element events to DOM
     *
     */
    updateEvents(){
      this.querySelectorAll('[data-item-remove]').forEach(button => {
        button.removeEventListener('click', this._onRemoveItemClick);
        button.addEventListener('click', this._onRemoveItemClick);
      });
      this.querySelectorAll('[data-qty-btn]').forEach(button => {
        button.removeEventListener('click', this._onQtyBtnClick);
        button.addEventListener('click', this._onQtyBtnClick);
      });
      this.querySelectorAll('[data-qty-input]').forEach(input => {
        input.removeEventListener('change', this._onQtyInputChange);
        input.addEventListener('change', this._onQtyInputChange);
      });
    }

    async getUpsell() {
  
      let cartData = await this.fetchCart();
      if(cartData.items.length > 0 && this.querySelector('.cart-related_items') != null){
        let productId = cartData.items[0].product_id;
        let related_products = await this.getRecommendedProducts(productId);

        // The JSON recommendations API can't read product metafields, so it returns
        // B2B/internal products that every other recommendation surface filters out
        // via custom.d2c_hidden / custom.b2b_hidden. Apply the same canonical filter
        // using the liquid-rendered allow-list.
        let allowedIds = await this.getAllowedRecommendationIds(productId);
        if (Array.isArray(allowedIds)) {
          let allowedSet = new Set(allowedIds);
          related_products = related_products.filter(p => allowedSet.has(String(p.id)));
        }
        related_products = related_products.slice(0, 6);

        if(related_products.length > 0){
          let upsellHTML = this.upsellHTML(related_products);
          this.querySelector('.cart-related_items').innerHTML = upsellHTML;
          this.dynamicEleEvents();
          this.querySelector('.cart-related_loader').classList.remove('loading')
          this.querySelector('.cart_related-products').classList.remove('d-none')
          this.optionSelection();
          this.addUpsell();
        } else {
          this.querySelector('.cart_related-products')?.classList.add('d-none')
        }
      } else {
        this.querySelector('.cart_related-products')?.classList.add('d-none')
      }
      
    
    }
    
    fetchCart() {
      return new Promise((resolve, reject) => {
        fetch('/cart.js', { method: 'GET' })
          .then(response => response.json())
          .then(cartData => {
            resolve(cartData);
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
            reject(error);
          });
      });
    }

    getRecommendedProducts(productId){
      return new Promise((resolve, reject) => {
        fetch(`/recommendations/products.json?product_id=${productId}&limit=10&intent=related`)
          .then(response => response.json())
          .then(({ products }) => {
            if (products.length > 0) {
              resolve(products);
            } else {
              reject(new Error('No recommended products found.'));
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }

    // Fetches the liquid-rendered allow-list of recommended product IDs that are
    // visible to the current customer, applying the B2B/D2C metafield rules the
    // JSON recommendations API can't see. Resolves null when unavailable so the
    // caller falls back to the unfiltered list rather than hiding everything.
    getAllowedRecommendationIds(productId){
      return new Promise((resolve) => {
        let baseUrl = (window.routes && routes.product_recommendations_url) || '/recommendations/products';
        fetch(`${baseUrl}?section_id=cart-upsell-recommendations&product_id=${productId}&intent=related&limit=10`)
          .then(response => response.text())
          .then(text => {
            let html = document.createElement('div');
            html.innerHTML = text;
            let dataEl = html.querySelector('[data-cart-upsell-allowed]');
            if (dataEl) {
              try {
                resolve(JSON.parse(dataEl.textContent).map(String));
                return;
              } catch (e) { /* fall through to null */ }
            }
            resolve(null);
          })
          .catch(() => resolve(null));
      });
    }

    upsellHTML(related_products){
      var btnHTML ='';
      let productHTML = "";
      related_products.forEach(related_product => {
        var allProductOptions = "";
        for(const option of related_product.options){
          let optionHtml = ``;
          let isOptions = false;
          for (const value of option.values) { 
            if(value != 'Default Title'){
              isOptions = true;
              let temp = `<option value="${value}">${value}</option>`;
              optionHtml += temp;
            }
          }
          if(isOptions){
            btnHTML = `
              <button
                class="btn btn-outline-secondary btn-sm flex-grow-1 px-2 quickshop--button"
                type="button"
                data-handle="${related_product.handle}"
                title="${related_product.handle}"
                aria-label="${related_product.handle}"
                data-toggle="tooltip"
                data-trigger="hover"
                data-placement="top"
                >
                <span class="add-text">Quick add</span>
              </button>`

            // let tempHtml = `
            //   <div class="">
            //     <h6 class="fs-sm form__label fw-bold lh-sm ls-sm mb-0 text-primary text-uppercase pe-2" >${option.name}:</h6>
            //     <select class="form-select bg-white" data-option-select>
            //       ${optionHtml}
            //     </select>
            //   </div>
            // `;
            // allProductOptions += tempHtml;
          }
          else{
            btnHTML = `
            <button class="btn btn-outline-secondary btn-sm flex-grow-1 px-2"
              type="submit"
              data-add-upsell-btn
              >
              <span class="add-text">
                ${related_product.variants[0].available ? `Add` : 'Out Of Stock'}
              </span>
              <span class="spinner-border"></span>
            </button>`
          }
        }

        productHTML += `
        <div class="cart-related_item h-auto d-flex swiper-slide h-auto d-flex">
          <div class="card card-product card-product-style-2 text-start rounded-0 border-0 h-100 flex-row" data-product-grid>
            <div class="card-img text-center" >
              <a href="${related_product.url}" class="d-block product-link rounded-2 overflow-hidden" >
                ${ related_product.featured_image ? `<img
                src="${related_product.featured_image}&width=250"
                loading="lazy"
                data-feauredImage
                alt="${related_product.title}"
                width="250"
                height="250"
              >` : `<img srcset="//joola-usa.myshopify.com/cdn/shop/files/Blog-Default-Missing-Featured-Image.jpg?v=1710415346&amp;width=230" 
              loading="lazy" src="//joola-usa.myshopify.com/cdn/shop/files/Blog-Default-Missing-Featured-Image.jpg?v=1710415346" 
              alt="joola-default-image" width="610" height="610.0">` }
              </a>
            </div>
            <div class="card-body ps-3 pt-0 pb-0 pe-0">
              <div class="row no-gutter">
                <div class="col-12">
                  <h6 class="card-title font-family-base fs-sm mb-0 mt-2 pt-1 text-capitalize">
                     <a href="${related_product.url}">${related_product.title}</a>
                  </h6>
                  <div class="row ps-0 pe-0 cart-dropdown">
                    ${allProductOptions}
                  </div>
                </div>
                <div class="col-12 text-start pb-05 mt-auto">
                  <span class="price m-0 pb-0 money fs-xs fw-medium text-body" data-currentPrice>
                    ${Utility.formatMoney(related_product.variants[0].price)}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div class="col-12 pt-1">
                <upsell-form>
                  <input type="hidden" name="id" value="${related_product.variants[0].id}" data-upsell-variant-id>
                  <div class="row">
                    <div class="col-12 d-flex">
                      ${btnHTML}
                    </div>
                  </div>
                </upsell-form>
              </div>
            </div>
          </div>
          <script data-upsell-products-json type="application/json">
            ${JSON.stringify(related_product)}
          </script>
        </div>
        `
      });
      return productHTML;
    }

  
    dynamicEleEvents(){
      if(drawerSelectors.quickShopModal && typeof drawerSelectors.quickShopModal.updateEvents == 'function'){ 
        drawerSelectors.quickShopModal.updateEvents(); 
      }
    }


    optionSelection(){
      let optionDropdowns = document.querySelectorAll('[data-option-select]');
      optionDropdowns.forEach(optionDropdown => {
        optionDropdown?.addEventListener('change', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
         
          let options = this._getOptionsFromSelect(event);
      
          let producData = JSON.parse(event.target.closest('.cart-related_item').querySelector('[data-upsell-products-json]').innerText);
          let variantsArray = producData.variants;
          let selectedVariant;
          variantsArray.find((variant) => {
            let mappedValues = variant.options.map((option, index) => {
              return options[index] === option;
            });
      
            if(!mappedValues.includes(false)){
              selectedVariant = variant;
            }
          });
         
          if(selectedVariant){
            event.target.closest('.cart-related_item').querySelector('[data-upsell-variant-id]').value = selectedVariant.id;
          }

          
        })
      })
    }
    _getOptionsFromSelect(event) {
      let options = [];
      event.target.closest('.cart-related_item').querySelectorAll('[data-option-select]').forEach((selector)=>{
        options.push(selector.value);
      });
      return options;
    }

    addUpsell(){
      let addBtns = document.querySelectorAll('[data-add-upsell-btn]');
      addBtns.forEach(el=> {
        el.addEventListener('click', (event) => {
          event.stopImmediatePropagation();
          event.preventDefault();
          let $form = event.target.closest('upsell-form');
          $form.querySelector('[type="submit"]').classList.add('loading');
          let variantID = event.target.closest('upsell-form').querySelector('input').value;
          let body = JSON.stringify({
            "id":parseInt(variantID),
            "quantity":1
          });
          fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((res) => {
            let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
            if(dataJSON.errors){
              window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
                type: 'error',
                timeout: 5000
              });
            }
      
            document.querySelector('cart-form').getCartData('open_drawer');
           
          })
          .catch((e) => {
            window.notificationEle.updateNotification('Add to Cart', 'Something went wrong. Please refresh and try again.', {
              type: 'error',
              timeout: 5000
            });
            console.error(e);
          })
          .finally(() => {
            $form.querySelector('[type="submit"]').classList.remove('loading');
            $form.querySelector('[type="submit"]').removeAttribute('disabled');
          });
        });
      });

     
    }
    
  
    /**
     * Open Cart drawer and add focus to drawer container
     *
     * @param {event} Event instance
     */
    openCartDrawer(event) {
      if (window.customer?.b2b) {
        if (event) event.preventDefault();
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
      if(!window.globalVariables.cart_drawer){
        window.location.href = window.routes.cart_fetch_url || '/cart';
        return;
      }
  
      if(document.querySelector('#mobile-menu-drawer').classList.contains('opened-drawer')){
        document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
      }
  
      this.classList.add('opened-drawer');
      siteOverlay.prototype.showOverlay();
      Utility.forceFocus(this.querySelector('.cart-title'));
      Utility.trapFocus(this, drawerSelectors.cartCloseBtn);
  
      if(event){
        event.preventDefault();
        let openBy = event.currentTarget;
        openBy.setAttribute('aria-expanded', true);
      }
    }
  
    /**
     * Close Cart drawer and Remove focus from drawer container
     *
     * @param {event} Event instance
     */
    closeCartDrawer(event, elementToFocus = false) {
      if (event == undefined) return;

      event.preventDefault();
      this.classList.remove('opened-drawer');
      siteOverlay.prototype.hideOverlay();

      let openByEle = event.currentTarget;
      openByEle.setAttribute('aria-expanded', false);
      Utility.removeTrapFocus(elementToFocus);

      let actionBtn = drawerSelectors.cartIconDesktop;
      if(window.innerWidth < 1024){
        actionBtn = drawerSelectors.cartIconMobile;
      }
      Utility.forceFocus(actionBtn);
    }
  
    /**
     * Update cart HTML and Trigger Open Drawer event
     *
     * @param {string} cartHTML String formatted response from fetch cart.js call
     * @param {string} action Open Drawer as value if need to Open Cart drawer
     */
    _updateCart(response, action){
      if(response === null) return;

      this.setAttribute('updating', true);

      return new Promise((resolve) => {
        let cartHTML = response[this.sectionID];
        let parser = new DOMParser();
        cartHTML = parser.parseFromString(cartHTML, 'text/html');
        resolve(cartHTML);
      })
      .then((cartHTML) => {
        const cartJSONEle = cartHTML.querySelector('[data-cartScriptJSON]');
        window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);

        const cartElement = cartHTML.querySelector('form');
        this.cartForm.innerHTML = cartElement.innerHTML;

        const cartTotal = Utility.formatMoney(
          window.globalVariables.cart.total_price,
          window.globalVariables.money_format
        );
        this.querySelectorAll('[data-cart-total]').forEach(function (el) {
          el.innerHTML = cartTotal;
        });

        const cart_items_count = cartHTML.querySelector('[data-item-count]');
        if (cart_items_count) {
          this.querySelector('[data-item-count]').innerHTML = cart_items_count.innerHTML;
        }

        const elements = this.querySelectorAll('[data-checkoutBtns], [data-cartnote], [data-cart-subtotal]');
        const cart_container = this.querySelector('.cart-form-container');

        if (window.globalVariables.cart.item_count <= 0) {
          elements.forEach((div) => div.classList.add('d-none'));
          cart_container.classList.add('empty_cart', 'd-flex', 'flex-column');
        } else {
          elements.forEach((div) => div.classList.remove('d-none'));
          cart_container.classList.remove('empty_cart', 'd-flex', 'flex-column');
        }

        return response['header'];
      })
      .then((headerHTMLString) => {
        const headerHTML = new DOMParser().parseFromString(headerHTMLString, 'text/html');
        const cartIcon = headerHTML.getElementById('cart-icon-desktop');

        if (drawerSelectors.cartIconDesktop) {
          drawerSelectors.cartIconDesktop.innerHTML = cartIcon.innerHTML;
        }
        if (drawerSelectors.cartIconMobile) {
          drawerSelectors.cartIconMobile.innerHTML = cartIcon.innerHTML;
        }
      })
      .then(() => {
        if (
          window.globalVariables.template !== 'cart' &&
          window.globalVariables.cart_drawer &&
          action === 'open_drawer'
        ) {
          this.openCartDrawer();
        }
      })
      .catch((e) => console.error('[UpdateCart Error]', e))
      .finally(() => this.setAttribute('updating', false));
    }

    getBxgyDetails(){
      if(Array.isArray(this.bxgyDiscountDetails)) return this.bxgyDiscountDetails;
      return fetch(`https://${window.location.hostname}/apps/joola-app/buy-x-get-y-discounts`, { method: "POST" })
      .then(response=>response.json())
      .then((data) => {
        if(data.error) {
          this.bxgyDiscountDetails = [];
          return this.bxgyDiscountDetails
        }
        this.bxgyDiscountDetails = data;
        return this.bxgyDiscountDetails;
      })
    }
    
    addBxgyProduct(products){
      if(products.length == 0) return Promise.resolve();
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': products.map((_)=>({
            id:_.variantId,
            quantity:_.quantity
          }))
        })
      })
      .then(response => response.json())
    }

    removeBxgyProduct(products){
      if(products.length == 0) return Promise.resolve();
      return fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify ({
          updates: products.reduce((acc,item)=>{
            acc[item.id] = 0;
            return acc;
          }, {})
        })
      })
    }

    handleBxgyDetails(bxgyDetails,cart){
      const bxgyCartDetails = bxgyDetails.map(({configuration, discount:details}) => {
        const discount = {}
        discount.title = details.title
        discount.x = {
          id: configuration.jsonValue.productX.map(product=>product.split("/").pop()),
          qty: 1
        }
        discount.y = {
          id:  configuration.jsonValue.productY.split("/").pop(),
          qty: 1
        }
        discount.x.line = cart.items.filter(({variant_id})=>discount.x.id.includes(`${variant_id}`));
        discount.x.totalQtyInCart = discount.x.line.reduce((acc,curr) => acc + curr.quantity , 0)
        discount.y.line = cart.items.filter(({variant_id})=>variant_id == discount.y.id);
        discount.y.totalQtyInCart = discount.y.line.reduce((acc, curr) => acc + curr.quantity, 0);
        if(discount.x.totalQtyInCart > discount.y.totalQtyInCart){
          const qtyVariation = discount.x.totalQtyInCart - discount.y.totalQtyInCart;
          if(qtyVariation > 0){
            discount.correction = {
              operation: "add",
              quantity: qtyVariation,
              id: discount.y.id
            }
          }
        }
        return discount;
      });
      const operations = bxgyCartDetails.map(({correction})=>{
        if(!correction) return Promise.resolve();
        if(correction.operation == 'add'){
          return this.addBxgyProduct([{
            variantId:correction.id,
            quantity:correction.quantity,
          }])
        }
      })
      return Promise.all(operations);
    }

    /**
     * Fetch latest cart data 
     *
     * @param {string} action Open Drawer as value if need to Open Cart drawer or else let it be empty
     */
    getCartData(action) {
    if (window.customer?.b2b && action === 'open_drawer') {
      action = undefined;
    }
    return Promise.all([this.getBxgyDetails(), fetch(window.Shopify.routes.root + 'cart.js').then(res=>res.json())])
    .then(([bxgyDetails, cartDetails]) => {
      if(window?.customer?.b2b){
        return Promise.resolve()
      }else{
        if(!Array.isArray(bxgyDetails)) return Promise.resolve();
        return this.handleBxgyDetails(bxgyDetails, cartDetails)
      }
    })
    .then(()=>fetch(`${window.location.pathname}?sections=${this.sectionID},header`))
    .then(response => response.json())
    .then(response => {
      return Promise.all([
        this._updateCart(response, action),
        this.getUpsell()
      ])
    })
    .then(() => {
      if (window.customer?.b2b) {
        return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) throw new Error('cart');
            return res.json();
          })
          .then(function (cart) {
            if (window.globalVariables) window.globalVariables.cart = cart;
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          });
      }
      if (window.globalVariables && window.globalVariables.cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: window.globalVariables.cart } })
        );
      }
    })
    .catch((e) => {
      console.error(e);
      if (window.globalVariables && window.globalVariables.cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: window.globalVariables.cart } })
        );
      }
      return [];
    })
    }
  
     
    isB2bShoppingBagCart() {
      if (typeof window.customer === 'undefined' || !window.customer.b2b) return false;
      return (
        this.classList.contains('shopping-bag-b2b--drawer') ||
        !!this.querySelector('.shopping-bag-b2b__body')
      );
    }

     /**
     * Update Quantity API call 
     *
     * @param {string} line Line Index value of cart Item (Starts from 1)
     * @param {integer} quantity Quantity to update
     * @param {string} lineKey Cart line key
     * @param {object} opts Optional: { b2bRapidWrap: true } — chain with PDP/collection B2B lock + queue
     */
    updateItemQty(line, quantity, lineKey, opts){
      opts = opts || {};
      const b2bRapidWrap = opts.b2bRapidWrap === true && this.isB2bShoppingBagCart();

      let lineItem;
      if (lineKey) {
        lineItem = Array.from(this.querySelectorAll('[data-cart-item]')).find(function (el) {
          return el.dataset.cartLineKey === lineKey;
        });
      } else {
        lineItem = this.querySelectorAll('[data-cart-item]')[parseInt(line, 10) - 1];
      }

      if(lineItem){ lineItem.classList.add('updating'); }
      const qty = parseInt(quantity, 10);
      const payload = lineKey
        ? { id: lineKey, quantity: qty }
        : { line: parseInt(line, 10), quantity: qty };
      const body = JSON.stringify(payload);
      const _this = this;

      const runFetch = function () {
        return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body }})
          .then(function (response) {
            return response.text();
          })
          .then(function (text) {
            var dataJSON;
            try {
              dataJSON = typeof text === 'string' && text ? JSON.parse(text) : text;
            } catch (e) {
              dataJSON = {};
            }
            if(dataJSON.errors){
              window.notificationEle.updateNotification('Cart Update', dataJSON.errors, {
                type: 'error',
                timeout: 5000
              });
            }
            return Promise.all([_this.getCartData(),_this.getUpsell()]);
          }).catch(function () {
            window.notificationEle.updateNotification('Cart Update', 'Something went wrong. Please refresh and try again.', {
              type: 'error',
              timeout: 5000
            });
          });
      };

      var finish = function () {
        setTimeout(function () {
          if(lineItem){ lineItem.classList.remove('updating'); }
        }, 500);
      };

      const runThroughShopifyQueue = function () {
        if (window.ShopifyCartMutationQueue && typeof window.ShopifyCartMutationQueue.enqueue === 'function') {
          return window.ShopifyCartMutationQueue.enqueue(runFetch);
        }
        return runFetch();
      };

      if (b2bRapidWrap && typeof window.enqueueB2bCartSync === 'function') {
        return window.enqueueB2bCartSync(function () {
          if (typeof window.setB2bQtyGlobalLock === 'function') window.setB2bQtyGlobalLock(true);
          return runThroughShopifyQueue().finally(function () {
            if (typeof window.setB2bQtyGlobalLock === 'function') window.setB2bQtyGlobalLock(false);
          });
        }).finally(finish);
      }

      if (window.ShopifyCartMutationQueue && typeof window.ShopifyCartMutationQueue.enqueue === 'function') {
        return window.ShopifyCartMutationQueue.enqueue(runFetch).finally(finish);
      }
      return runFetch().finally(finish);
    }
  
    /**
     * Remove Item Event
     *
     * @param {event} Event instance
     */
    removeItem(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let itemIndex = currentTarget.dataset.index || null;
      let lineKey = currentTarget.dataset.lineKey || null;
      if(itemIndex !== null){
          this.updateItemQty(
            itemIndex,
            0,
            lineKey,
            this.isB2bShoppingBagCart() ? { b2bRapidWrap: true } : undefined
          );
      }
      
    }
  
    /**
     * Cart Item Qunatity Increment/Decrement Button 
     * 
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event){
      event.preventDefault();
      let currentTarget = event.currentTarget;
      let action = currentTarget.dataset.for || 'increase';
      let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
      let itemIndex = $qtyInput.dataset.index || 1;
      let lineKey = $qtyInput.dataset.lineKey || null;

      let stepQty = ($qtyInput.step) ? parseInt($qtyInput.step) : 1;
      let minQty = ($qtyInput.min) ? parseInt($qtyInput.min) : 1;
      let maxQty = ($qtyInput.max) ? parseInt($qtyInput.max) : null;

      let currentQty = parseInt($qtyInput.value) || minQty;
      let finalQty = currentQty;
  
      if(action === 'decrease' && currentQty <= minQty){
        return false;
      }else if(action === 'decrease'){
        finalQty = currentQty - stepQty;
      }else{
        finalQty = currentQty + stepQty;
      }

      if (maxQty != null && finalQty > maxQty) {
        finalQty = maxQty;
      }

      if (this.isB2bShoppingBagCart()) {
        if ((window.__b2bQtyGlobalLockCount || 0) > 0) {
          return false;
        }
        $qtyInput.value = String(finalQty);
        var timerKey = lineKey || String(itemIndex);
        var _this = this;
        clearTimeout(this._b2bBagDebounceTimers[timerKey]);
        this._b2bBagDebounceTimers[timerKey] = setTimeout(function () {
          var raw = String($qtyInput.value).replace(/[^0-9]/g, '');
          var v = raw === '' ? minQty : parseInt(raw, 10);
          if (!Number.isFinite(v)) v = minQty;
          v = Math.max(minQty, v);
          if (maxQty != null) v = Math.min(maxQty, v);
          _this.updateItemQty(itemIndex, v, lineKey, { b2bRapidWrap: true });
        }, B2B_BAG_QTY_DEBOUNCE_MS);
        return;
      }

      this.updateItemQty(itemIndex, finalQty, lineKey);
      
      // if(maxQty != null && finalQty <= maxQty && finalQty >= minQty){
      //   this.updateItemQty(itemIndex, finalQty);
      // }else if(finalQty >= minQty){ 
        
      // }
    }

    /**
     * Cart Item Qunatity Input change event
     *
     * @param {event} Event instance
     */
    onQtyChange(event){
      const $qtyInput = event.currentTarget;
      const qtyValue = $qtyInput.value;
      const itemIndex = $qtyInput.dataset.index || null;
      const lineKey = $qtyInput.dataset.lineKey || null;
      if (!itemIndex) return;

      if (this.isB2bShoppingBagCart()) {
        if ((window.__b2bQtyGlobalLockCount || 0) > 0) {
          return;
        }
        var timerKey = lineKey || String(itemIndex);
        clearTimeout(this._b2bBagDebounceTimers[timerKey]);
        this.updateItemQty(itemIndex, qtyValue, lineKey, { b2bRapidWrap: true });
        return;
      }

      this.updateItemQty(itemIndex, qtyValue, lineKey);
    }

    /**
     * Manage Cart Notes
     */
    cartNoteInput(){
      const cartNoteEle = document.querySelector('[data-cartNote] [name="note"]');
      if(!cartNoteEle) return;

      const cartNoteSave = document.querySelector('[data-saveNote]');
      let cartNoteEvents = ['input', 'paste'];
      cartNoteEvents.forEach((eventName)=>{
        cartNoteEle.addEventListener( eventName, (evt)=> {
          const defaultNote = cartNoteEle.dataset.default;
          if(defaultNote !== cartNoteEle.value){
            cartNoteSave.style.display = 'block';
          }else{
            cartNoteSave.style.display = 'none';
          }
        }, false);
      });

      //  Cart Note Change event
      cartNoteSave.addEventListener( "click", evt => {
        evt.preventDefault();
        const cartNoteContainer = evt.currentTarget.closest('[data-cartNote]');
        const cartNote = cartNoteContainer.querySelector('[name="note"]').value.trim();
        if(cartNote.length <= 0){
          alert('Add Note before proceeding');
          return;
        }
        
        const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
        const waitText = (submitBtn.dataset.adding_txt) ? submitBtn.dataset.adding_txt : 'Saving...';
        submitBtn.innerHTML = waitText;
        submitBtn.disabled = true;
        this.updateCartNote(cartNoteContainer);
      });
    }

    /**
     * Update Cart Note
     * @param {element} cartNoteContainer 
     */
    updateCartNote(cartNoteContainer){
      const _this = this;
      const cartNoteEle = cartNoteContainer.querySelector('[name="note"]');
      const cartNote = cartNoteEle.value.trim();
      const resultEle = cartNoteContainer.querySelector('[data-resultMsg]');
      const submitBtn = cartNoteContainer.querySelector('[data-saveNote]');
      const defaultText = (submitBtn.dataset.default) ? submitBtn.dataset.default : 'Save';

      let body = JSON.stringify({
        note: cartNote
      });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body }
      }).then(function (data) {
        if (data.status === 200) {
          if(resultEle){
            resultEle.innerText = 'Added note to Order!';
            _this.manageResponseText(resultEle);
          }
          if(cartNoteEle){
            cartNoteEle.dataset.default = cartNote;
          }
          submitBtn.style.display = 'none';
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
        else {
          console.error('Request returned an error', data);
          if(resultEle){
            resultEle.innerText = data;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
        }
      }).catch(function (error) {
          console.error('Request failed', error);
          if(resultEle){
            resultEle.innerText = error;
            _this.manageResponseText(resultEle);
          }
          submitBtn.innerHTML = defaultText;
          submitBtn.disabled = false;
      });
    }

    /**
     * fade effect on reponse
     * @param {element} element 
     */
    manageResponseText(element){
      Utility.fadeEffect(element, 'fadeIn');
      setTimeout(() => {
          Utility.fadeEffect(element, 'fadeOut');
      }, 3000);
    }
}
customElements.define("cart-form", AjaxCart);